<!-- Side Structure -->
<template>
  	<div class="sidebar" :class="sidebarSelectedFilter.class">
    	<vue-perfect-scrollbar class="scroll-area" :settings="settings">
        <v-toolbar flat class="transparent scroll-area navigation">
          <v-list>
				<app-logo></app-logo>
            <user-block></user-block>
				<template v-for="(category, key) in menus">
					<div :key="key">
						<div class="sidebar-title px-3">
							<span>{{category.Descr}}</span>
						</div>
						<template v-for="item in category.MenuItems">
							<template v-if="item.Childs.length > 0">
								<v-list-group
									:key="item.Title"
									prepend-icon="arrow_right"
									append-icon=""
									no-action
									v-model="item.active"
								>
									<v-list-tile slot="activator">
										<v-list-tile-content>
											<v-list-tile-title>
												<i class="mr-2 zmdi" :class="item.Icon"></i>
												<span>{{ textTruncate($t(item.Title)) }}</span>
											</v-list-tile-title>
										</v-list-tile-content>
									</v-list-tile>
									<v-list-tile 
										v-for="subItem in item.Childs" 
										v-bind:key="subItem.Title" 
										v-if="subItem !== null"
										:to="!subItem.exact ? `/${getCurrentAppLayoutHandler() + subItem.Path}` : subItem.Path"
									>
										<v-list-tile-content>
											<v-list-tile-title>{{ textTruncate($t(subItem.Title)) }}</v-list-tile-title>
										</v-list-tile-content>
									</v-list-tile>
								</v-list-group>
							</template>
							<template v-else>
								<v-list-tile
									:to="!item.exact ? `/${getCurrentAppLayoutHandler() + item.Path}` : item.Path"
									:key="item.Path"
								>
									<v-list-tile-action>
										<i class="zmdi zmdi-caret-right"></i>
									</v-list-tile-action>
									<v-list-tile-content>
										<v-list-tile-title>
											<i class="mr-2 zmdi" :class="item.Icon"></i>
											<span>{{ textTruncate($t(item.Title)) }}</span>
										</v-list-tile-title>
									</v-list-tile-content>
								</v-list-tile>
							</template>
						</template>
					</div>
				</template>     
          </v-list>
        </v-toolbar>
    	</vue-perfect-scrollbar>
  	</div>
</template>

<script>
import UserBlock from "./UserBlock";
import { textTruncate, getCurrentAppLayout } from "Helpers/helpers";
import { mapGetters } from "vuex";
import AppLogo from "Components/AppLogo/AppLogo";
import Vue from 'vue';
import router from '../../router';

export default {
  data() {
    return {
      settings: {
        maxScrollbarLength: 160
      }
    };
  },
  components: {
    UserBlock,
    AppLogo
  },
  computed: {
		...mapGetters(["sidebarSelectedFilter"]),
		menus () {
			console.log (Vue.$StoreMenu);

			if (Vue.$StoreMenu.length > 0)
			{
				//console.log ("Storemenu is WEL gekend");
			}
			else
			{
				router.push("/session/login");
			}
			

			return Vue.$StoreMenu;
		}
  },
	mounted(){
		this.$store.dispatch("setActiveMenuGroup", this.$router);
	},
  methods: {
    textTruncate(text) {
      return textTruncate(text, 30);
    },
    getCurrentAppLayoutHandler() {
      return getCurrentAppLayout(this.$router);
    }
  }
};
</script>
